import { Pipe, PipeTransform } from "@angular/core";
import {
  IWorkorderOrServiceRequestSummary,
  IWorkorderRequestSummary,
  RequestSourceTypeEnum,
  workorderTypeEnum,
} from "../models/request";

@Pipe({
  name: "isInternalWorkorderRequest",
})
export class isInternalWorkorderRequestPipe implements PipeTransform {
  transform(
    workorderRequest: IWorkorderOrServiceRequestSummary,
    ...args: unknown[]
  ): unknown {
    if (!(workorderRequest.source === RequestSourceTypeEnum.workorderRequest)) {
      return null;
    }
    return workorderRequest?.type === workorderTypeEnum.internal;
  }
}
